export const API_ENDPOINTS = {
  SESSION: "/api/session",
  LOGOUT: "/api/logout",
  LOGIN: "/api/login",
  SIGNUP: "/api/signup",
  GENERATE_CHOICES: "/api/generate_choices",
  WHEELS: "/api/wheels",
  FAVORITES: "/api/favorites",
  PREMIUM_PASS: "/api/premium_pass",
  PARK_ENTITIES: "/api/park_entities",
}
